import { LogOut } from "lucide-react"
import { Button } from "./button"
import {
  AppDialog,
  AppDialogClose,
  AppDialogFooter,
} from "@/components/app/app-dialog"

interface LogoutModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function LogoutModal({ isOpen, onConfirm, onCancel }: LogoutModalProps) {
  return (
    <AppDialog open={isOpen} onClose={onCancel}>
      <AppDialogClose onClose={onCancel} />

      {/* Icon */}
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
        <LogOut className="h-6 w-6 text-destructive" />
      </div>

      {/* Content */}
      <div className="text-center">
        <h2 className="text-lg font-semibold">Confirm Logout</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Are you sure you want to log out? You will need to sign in again to
          access the platform.
        </p>
      </div>

      {/* Actions */}
      <AppDialogFooter>
        <Button variant="outline" className="flex-1" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="destructive" className="flex-1" onClick={onConfirm}>
          Logout
        </Button>
      </AppDialogFooter>
    </AppDialog>
  )
}
